import { AlloyButton, ToastContext } from 'cat-ecommerce-alloy';
import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { STATUS } from '@app/constants/commonConstants';
import { getCommonVars } from '@app/store/common/actions';
import { getCurrentOrderInfo } from '@app/store/orders/actions';
import { ERROR_DOMAIN, ERROR_PATH } from '@app/constants/errorConstants';
import PropTypes from 'prop-types';
import { CHECKOUT_SET_ORDER_INFORMATION_IDLE } from '@app/store/checkout/constants';

const UpdateCartCancelButtons = ({ disableUpdateButton, closeModal }) => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const orderInformationStatus = useSelector(
    s => s.checkout.setOrderInformationStatus
  );
  const toastCtx = useContext(ToastContext);

  /**
   * After changing the store we need to refresh the cart's information via several service calls
   */
  useEffect(() => {
    if (orderInformationStatus === STATUS.RESOLVED) {
      const errorInfo = {
        domain: ERROR_DOMAIN.CART,
        path: ERROR_PATH.MAIN
      };
      dispatch(getCommonVars({ errorInfo }));
      dispatch(getCurrentOrderInfo({ errorInfo, isInitialCartCall: true }));
      dispatch({ type: CHECKOUT_SET_ORDER_INFORMATION_IDLE });
      closeModal();
      toastCtx.createSuccessToast(t('SAVE_ORDER_INFO_SUCCESS_TOAST'));
    }
  }, [dispatch, orderInformationStatus, closeModal, t, toastCtx]);

  return (
    <div
      className={
        'd-flex w-100 justify-content-between flex-column-reverse flex-lg-row'
      }
    >
      <AlloyButton
        buttonType="ghost"
        className="ps-lg-0 mt-2"
        size="small"
        onClick={closeModal}
      >
        {t('MO_CancelButton')}
      </AlloyButton>
      <AlloyButton
        buttonType="primary"
        className="mt-2 mb-1 mb-lg-0"
        size="small"
        disabled={disableUpdateButton}
        type="submit"
      >
        {t('UPDATE_CART')}
      </AlloyButton>
    </div>
  );
};

export default UpdateCartCancelButtons;

UpdateCartCancelButtons.propTypes = {
  disableUpdateButton: PropTypes.bool,
  closeModal: PropTypes.func.isRequired
};
